import { Link, useLocation } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";
import { BRAND } from "@/lib/brand";

const columns = [
  {
    title: "Explore",
    links: [
      { label: "Our Rituals", to: "/products" },
      { label: "The 3-Way System", to: "/three-way-system" },
      { label: "Journal", to: "/journal" },
      { label: "Stories", to: "/stories" },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Rituals With You", to: "/community" },
      { label: "Programmes", to: "/programmes" },
      { label: "Join the Community", to: "/join" },
      { label: "My Rituals", to: "/my-rituals" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "Our Story", to: "/about" },
      { label: "FAQ", to: "/faq" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
    ],
  },
];

export default function Footer() {
  const flush = useLocation().pathname === "/";
  return (
    <footer className={`relative bg-forest text-ivory overflow-hidden grain ${flush ? "border-t border-ivory/10" : "mt-28"}`} data-testid="site-footer">
      <BrandLogo
        variant="mark"
        tone="light"
        className="pointer-events-none select-none absolute -right-16 -bottom-24 w-[440px] opacity-[0.05]"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <BrandLogo tone="light" className="h-28 sm:h-32 w-auto" />
            <p className="mt-8 font-serif italic text-2xl text-champagne">{BRAND.tagline}</p>
            <p className="mt-4 text-sm text-ivory/65 leading-relaxed max-w-sm font-light">
              Rituals With You — a community by ELA Rituals. A space to discover, experience
              and share, one ritual at a time.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10 lg:pt-4">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="text-[11px] uppercase tracking-[0.28em] text-champagne mb-6 font-medium">
                  {col.title}
                </h4>
                <ul className="space-y-3.5">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="text-sm text-ivory/70 hover:text-ivory transition-colors font-light">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-ivory/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[11px] uppercase tracking-[0.18em] text-ivory/50">
            © {new Date().getFullYear()} ELA Rituals · Preview build — commerce disabled
          </p>
          <p className="text-[11px] uppercase tracking-[0.18em] text-ivory/50">
            Imagery shown is placeholder art direction
          </p>
        </div>
      </div>
    </footer>
  );
}
